const msgOptions = {
  timeout: 3000,
  showProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  position: 'leftBottom',
  bodyMaxLength: 500,
  titleMaxLength: 100
}

export default {
  install (Vue) {
    Vue.mixin({
      methods: {
        $showSimple (body, title) {
          this.$snotify.warning(body, title, msgOptions)
        },
        $showSuccess (body, title) {
          this.$snotify.success(body, title, msgOptions)
        },
        $showError (body, title) {
          this.$snotify.error(body, title, msgOptions)
        },
        $showInfo (body, title) {
          this.$snotify.info(body, title, msgOptions)
        },
        $showWarning (body, title) {
          this.$snotify.warning(body, title, msgOptions)
        },
        $getLocaleErrorMessage (err, prefix) {
          // err => HTTP errors
          // err.data => Server errors

          if (!err.data) {
            return err.statusText || err.status || err
          } else {
            if (err.data.Code === 401 && err.data.Details !== 'loginFailed')
              return this.$t('shared.unauthorized')

            if (err.data.Code === 500) {
              return this.$t('shared.internalServerError')
            }

            if (err.data.statusCode === 400 && err.data.code === 'validationFailed')
              return this.$t('shared.validationFailed')

            const msg = err.data && (err.data.Details || err.data.Status || err.data.Code)
            if (msg) {
              if (prefix && this.$te(prefix + '.' + msg))
                return this.$t(prefix + '.' + msg)

              else if (this.$te('shared.' + msg))
                return this.$t('shared.' + msg)

              return msg
            }
            return err.statusText || err.status || err
          }
        }
      }
    })
  }
}
